'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    ', '\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 8px;\n    padding: .25rem .5rem;\n    margin-bottom: 2px;\n    border-radius: ', ';\n'], ['\n    ', '\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 8px;\n    padding: .25rem .5rem;\n    margin-bottom: 2px;\n    border-radius: ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _alignments = require('../../../constants/alignments');

var _sizes = require('../../../constants/sizes');

var _separator = require('../../../atoms/separator');

var _separator2 = _interopRequireDefault(_separator);

var _label = require('../../../atoms/text/label');

var _label2 = _interopRequireDefault(_label);

var _textArea = require('../../../atoms/textArea');

var _textArea2 = _interopRequireDefault(_textArea);

var _getFieldValidationInfo = require('../../../helpers/getFieldValidationInfo');

var _getFieldValidationInfo2 = _interopRequireDefault(_getFieldValidationInfo);

var _error = require('../../../atoms/icons/error');

var _error2 = _interopRequireDefault(_error);

var _colors = require('../../../constants/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ValidationBanner = _styledComponents2.default.div(_templateObject, function (_ref) {
	var type = _ref.type;

	switch (type) {
		case 'error':
			return 'background: rgba(255, 0, 78, .15);';
		case 'warning':
			return 'background: rgba(255, 129, 0, .15);';
		default:
			return null;
	}
}, function (_ref2) {
	var index = _ref2.index,
	    formattedValue = _ref2.formattedValue;
	return index === 0 && formattedValue ? '0 0 4px 4px' : '4px';
});

var FormTextArea = function (_React$Component) {
	_inherits(FormTextArea, _React$Component);

	function FormTextArea() {
		_classCallCheck(this, FormTextArea);

		return _possibleConstructorReturn(this, (FormTextArea.__proto__ || Object.getPrototypeOf(FormTextArea)).apply(this, arguments));
	}

	_createClass(FormTextArea, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _getFieldValidationIn = (0, _getFieldValidationInfo2.default)(this.props.validationInfo, this.props.pageCode, this.props.sectionCode, this.props.fieldCode, this.props.rowId),
			    errors = _getFieldValidationIn.errors,
			    warnings = _getFieldValidationIn.warnings;

			var editMode = this.props.editing && this.props.allowEdit;

			return _react2.default.createElement(
				_react2.default.Fragment,
				null,
				_react2.default.createElement(_separator2.default, { bottom: _sizes.Sizes.sm,
					orientation: 'horizontal',
					solid: true
				}),
				_react2.default.createElement(_textArea2.default, { readOnly: !editMode,
					text: this.props.text,
					placeholder: this.props.placeholder,
					rows: this.props.rows,
					changeEvent: this.props.changeEvent,
					error: errors.length > 0,
					serverErrors: errors,
					serverWarnings: warnings,
					sectionUIValidation: this.props.sectionUIValidation,
					bottom: this.props.bottom,
					disabled: !this.props.editing
				}),
				!editMode && _react2.default.createElement(
					_react2.default.Fragment,
					null,
					errors.length > 0 && errors.map(function (error, index) {
						return _react2.default.createElement(
							ValidationBanner,
							{ key: index,
								type: 'error',
								index: index,
								labelValue: _this2.props.text
							},
							_react2.default.createElement(_error2.default, { mode: 'error',
								size: 24
							}),
							_react2.default.createElement(_label2.default, { textAlign: _alignments.Alignments.left,
								text: error.message,
								color: _colors.Colors.Error
							})
						);
					}),
					warnings.length > 0 && warnings.map(function (warning, index) {
						return _react2.default.createElement(
							ValidationBanner,
							{ key: index,
								type: 'warning',
								index: index,
								labelValue: _this2.props.text
							},
							_react2.default.createElement(_error2.default, { mode: 'warning',
								size: 24
							}),
							_react2.default.createElement(_label2.default, { textAlign: _alignments.Alignments.left,
								text: warning.message,
								color: _colors.Colors.Warning
							})
						);
					})
				)
			);
		}
	}]);

	return FormTextArea;
}(_react2.default.Component);

exports.default = FormTextArea;